import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackBarService } from '../../services/snackBar.service';

@Component({
  selector: 'app-land-register-with-copy[landRegister]',
  templateUrl: './land-register-with-copy.component.html',
  styleUrls: ['./land-register-with-copy.component.scss']
})
export class LandRegisterWithCopyComponent implements OnChanges {
  @Input() landRegister: string = '';

  public lrMiddle: string = '';

  public readonly KW_LINK =
    '//przegladarka-ekw.ms.gov.pl/eukw_prz/KsiegiWieczyste/wyszukiwanieKW?komunikaty=true&kontakt=true&okienkoSerwisowe=false';

  constructor(private snackBarService: SnackBarService, private clipboard: Clipboard) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.landRegister) {
      const curr = changes.landRegister.currentValue;
      this.lrMiddle = curr ? curr.split('/')[1]?.trim() ?? '' : '';
    }
  }

  public copyToClipboard(): void {
    const $value = this.lrMiddle;
    if (this.lrMiddle && this.clipboard.copy(this.lrMiddle)) {
      this.snackBarService.showSuccess({ key: 'success.valueToClipboard', replaceMap: { $value } }, 'OK');
    } else {
      this.snackBarService.showError({ key: 'error.valueToClipboard', replaceMap: { $value } }, 'OK');
    }
  }
}
